<template>
  <div :class="bemBlock">
    <img
      :class="bemElement('img')"
      :src="imageUrl"
      :alt="complement"
      @load="$emit('complement-visualizer:show')"
    />
    <button
      v-if="editMode"
      :class="[bemElement('remove-button'), 'btn', 'btn-clean']"
      @click="handleRemoveClick"
    >
      <span class="icon" aria-hidden="true">+</span>
      <span class="sr-only"> Remove </span>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '../../store';
import getFrontConfig from '../../../common/getFrontConfig';
import bemClassesMixin from '../../mixins/bemClassesMixin';

const {
  urls: { customizerResources },
} = getFrontConfig();

export default {
  name: 'TheProductCustomizerComplementVisualizer',

  mixins: [bemClassesMixin],

  props: {
    complement: {
      type: String,
      required: true,
      default: null,
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapState({
      lockRemove: (state) => state.productCustomizer.lockRemove,
    }),
    imageUrl() {
      return `${
        customizerResources + this.complement.replaceAll('.', '_')
      }.png`;
    },
  },

  methods: {
    handleRemoveClick() {
      if (!this.lockRemove) {
        this.$store.commit(types.productCustomizer.lockRemove);
        this.$emit('complement-visualizer:remove');
      }
    },
  },
};
</script>
